import { getTheme } from 'mol-ui';
import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';

export const Col = styled(Col_)`

`;

export const Container = styled.div`

`;

export const Row = styled(Row_)`
    margin: 10px 0px 0px 0px;
    width: 100%;
`;

export const Text = styled.div `
    color: ${ getTheme('textColor') };
    font-size: 14px;
    margin-bottom: 10px;
    margin-top: 10px;
`;
